import {
    Badge,
    ColourSolid,
    ListItem,
    Modal,
    ModalSize,
    ModalType,
} from "@twigsby/frontend-framework";
import React, {useCallback} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {HarmonySearchResults} from "../Controls/HarmonySearchResults";

interface CommoditySearchModalType extends ModalType {
}

const HarmonySearchModal = (props: CommoditySearchModalType) => {
    const { commodityHeading, GetCommodityCodes, GetCommodityCodeHeading } = useForwardingBatchProvider();

    const HandleCodeSelection = (id: string, type?: string) => {
        if(type === 'Commodity') {
            console.log('HandleCodeSelection');
            props.actionedCallback(id);
        } else {
            GetCommodityCodeHeading(id);
        }

/*        switch(type) {
            case 'Heading':
                GetCommodityCodeHeading(id);
                break;
            case 'Subheading':
                GetCommodityCodeHeading(id);
                break;
            case 'Commodity':
                GetCommodityCodeHeading(id);
                break;
            default:
        }*/
    };

    const HandleNestedSelection = (id: string, type?: string) => {
        if(type === 'selected' && props.actionedCallback) {
            props.actionedCallback(id);
        } else {
            HandleCodeSelection(id);
        }
    }

    return (
        <Modal
            title={'Harmony Lookup'}
            isOpen={props.isOpen}
            closeCallback={props.closeCallback}
            modalSize={ModalSize.Large}
        >
            <div>
                <input type={"text"} onBlur={(e) => GetCommodityCodes(e.currentTarget.value)}/>
            </div>

            <div className={'row'}>
                <div className={commodityHeading.commodities ? 'col-md-6' : 'col-md-12'}>
                    <HarmonySearchResults
                        selectedCallback={(id: string, type: string) => HandleCodeSelection(id, type)}
                    />
                </div>
                {commodityHeading.commodities && (
                    <div className={'col-md-6'}>
                        <HarmonySearchDetailed
                            lookupCallback={(id: string, type: string) => HandleNestedSelection(id)}
                            selectedCallback={(id: string, type: string) => HandleNestedSelection(id, 'selected')}
                        />
                    </div>
                )}
            </div>

        </Modal>
    )
}

const HarmonySearchDetailed = (props: any) => {
    const {commodityHeading} = useForwardingBatchProvider();

    /*
    * code: "7201100000"
        declarable: false
        description: "Non-alloy pig iron containing by weight 0,5 % or less of phosphorus"
        endDate: null
        parentSid: null
        sid: 44813
        startDate: "1972-01-01T00:00:00Z"
    * */
    return (
        <div>
            {commodityHeading?.commodities?.map((item: any, index: number) =>
                item.declarable ?
                    <ListItem
                        hideArrow={true}
                        key={`commodityEntry${index}`}
                        title={`${item.description.replace('/<br>/gi', '\n')}`}
                        description={`${item.code}`}
                        addonLeft={<Badge colour={ColourSolid.Success} />}
                        onClick={() => props.selectedCallback(item.code)}
                    />
                :
                    <ListItem
                        static={true}
                        hideArrow={true}
                        key={`commodityEntry${index}`}
                        title={`${item.description.replace('/<br>/gi', '\n')}`}
                    />
            )}
        </div>
    )
}

export { HarmonySearchModal }
